function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, Array, String) {
    var h = require("panel").h;
    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const compositionParts = $attr(`composition-parts`);
    return {
      value: (h("div", {
        "class": {
          'custom-event-composition': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((function() {
          var $$obj = (compositionParts);
          var $$eachNodes;
          var $$iterated = false;
          if (Array.isArray($$obj)) {
            $$eachNodes = $$obj.reduce(function($$eachNodes, part, $index) {
              $$iterated = true;
              return $$eachNodes.concat((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("span", {
                  "class": {
                    highlight: part.highlight
                  },
                }, [__vjadeSafeCode(`${part.label} `)]));;
                return __jade_nodes
              }).call(this));
            }, []);
          } else {
            $$eachNodes = [];
            for (var $$objKey in $$obj) {
              (function() {
                var $index = $$objKey;
                if ($$obj.hasOwnProperty($index)) {
                  $$iterated = true;
                  var part = $$obj[$index];
                  $$eachNodes = $$eachNodes.concat((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("span", {
                      "class": {
                        highlight: part.highlight
                      },
                    }, [__vjadeSafeCode(`${part.label} `)]));;
                    return __jade_nodes
                  }).call(this));
                }
              })();
            }
          }

          return $$eachNodes;
        })());;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;